const Tabs = {
  baseStyle: {
    tab: {
      bgColor: 'red',
      color: 'red',
    },
    tabpanel: {},
  },
  variants: {
    line: {
      tablist: {
        borderBottom: 'none',
      },
      tab: {
        height: '60px',
        color: 'textPrimary',
        fontWeight: 600,
        borderBottomWidth: '4px',
        _active: {
          bgColor: 'transparent',
          borderColor: 'primary',
        },
        _selected: {
          borderColor: 'primary',
        },
      },
    },
  },
}

export default Tabs
